export const UserType = {
    Person: 0,
    Team: 1,
    SharedTeam: 2,
} as const;
